import React from 'react';
export function SiteFooter() {
  return <footer className="bg-white" data-id="element-72" data-mp="1dqrohw3lfk7t">
      <p className="mx-auto max-w-7xl px-6 py-6 text-xs text-ink-subtle" data-id="element-73" data-mp="3r89h9jm4jdlp">
        © {new Date().getFullYear()} NEXT OS · The operating system built at HomeSmart; by agents, for agents.
      </p>
    </footer>;
}